import { COLOR_GREEN_600, COLOR_NEUTRAL_700 } from '@alltrails/denali/tokens';
import { createCircleMarker, createPinMarker } from './svgMarkerComponents';

export const createActivityPinSvg = (imageName: string, isHovered: boolean = false) =>
  createPinMarker({ imageName, innerFill: isHovered ? COLOR_GREEN_600 : COLOR_NEUTRAL_700, renderInnerDot: true });

export const createActivityPinClusterSvg = (imageName: string, isHovered: boolean = false) =>
  createCircleMarker({ imageName, innerDiameter: 24, innerFill: isHovered ? COLOR_GREEN_600 : COLOR_NEUTRAL_700 });
